export default {
  name: 'module-manage',
  label: {
    title: '模块管理',
    icon: require('@/assets/icon-accessary_ModuleManage.png')
  },
  sort: 2
}
